import { Building2, Mail, MapPin } from "lucide-react";

// Componente para mostrar información del socio
const SocioInfoCard = ({ selectedSocio }) => (
  <div className="bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-xl p-6">
    <div className="flex items-center gap-3 mb-4">
      <Building2 className="text-[#0488AF]" size={24} />
      <div>
        <h3 className="text-xl font-bold text-[#09274A]">{selectedSocio.business_name}</h3>
        <p className="text-gray-600">{selectedSocio.trade_name}</p>
      </div>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div className="space-y-2">
        <div className="flex items-center gap-2 text-gray-700">
          <span className="font-semibold text-[#09274A]">RUT:</span>
          <span>{selectedSocio.rut}</span>
        </div>
        <div className="flex items-center gap-2 text-gray-700">
          <span className="font-semibold text-[#09274A]">Industria:</span>
          <span>{selectedSocio.industrie}</span>
        </div>
      </div>
      <div className="space-y-2">
        <div className="flex items-start gap-2 text-gray-700">
          <MapPin className="text-[#0488AF] mt-0.5" size={16} />
          <div>
            <div>{selectedSocio.address}</div>
            <div className="text-sm text-gray-500">
              {selectedSocio.district}, {selectedSocio.province}, {selectedSocio.region}
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2 text-gray-700">
          <Mail className="text-[#0488AF]" size={16} />
          <span>{selectedSocio.contact_email}</span>
        </div>
      </div>
    </div>
  </div>
);

export default SocioInfoCard;